<template>
  <div
    class="grid grid-cols-1 laptop:grid-cols-2 gap-8"
  >
    <template
      v-for="(item, index) in props.items"
      :key="index"
    >
      <div
        class="flex flex-row gap-2"
      >
        <div
          class="flex bg-primary aspect-square h-[2em] w-[2em] rounded-lg my-auto"
        >
          <font-awesome-icon
            :icon="item.icon"
            class="text-white text-[1.2em] m-auto"
          />
        </div>
        <p
          class="my-auto text-slate-900"
        >
          {{ item.text }}
        </p>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import type { Icon } from "~/utils/types";

const props = defineProps<{
  items: {
    icon: Icon
    text: string
  }[]
}>()
</script>
